<template>
  <div
    class="bg-primary-red mb-5 relative text-white some-card"
    :class="card.size === 'vertical' ? 'vertical' : 'square'"
  >
    <template v-if="!card.background && card.content">
      <div class="p-6 sm:p-5 md:p-6 lg:p-10 flex flex-col justify-center h-full">
        <div class="text-base lg:text-lg mb-4">
          {{ card.content.label }}
        </div>
        <h3
          class="text-3xl lg:text-6xl mb-3 lg:mb-6"
          v-html="card.content.title"
        />
        <div
          v-if="card.content.text"
          class="text-base sm:text-xl mb-6 font-light some-card-content"
          v-html="card.content.text"
        />
        <a
          v-if="card.content.link && card.content.link.url"
          :href="card.content.link.url"
          v-bind="card.content.link.attributes"
          class="btn bg-white text-primary-red self-start items-center text-sm font-bold"
          @click="trackCtaClick(card.content.title)"
        >
          <span>{{ card.content.link.text }}</span>
          <span class="icon-arrow-right text-xs ml-2" />
          <span class="icon-arrow-left text-xs mr-2 ltr:hidden" />
        </a>
      </div>
    </template>
    <template v-else-if="card.background">
      <so-me-video
        v-if="card.background.video"
        :model="card.background.video"
        :width="'467'"
        :height="'782'"
        :is-lazy="true"
        @videoPlayPressed="videoPlayPressed"
      />
      <Picture
        v-else-if="card.background.image"
        class="block h-full w-full some-media"
        height="100%"
        width="100%"
        v-bind="card.background.image"
        :mobile="[467, 0]"
        img-class="block w-full object-cover h-full object-center"
      />
      <div
        v-if="card.content.username"
        class="card-username absolute bottom-0 ltr:right-0 rtl:left-0 bg-white rounded-full text-primary-red text-xs flex items-center py-2 px-4 gap-1 ltr:mr-6 rtl:ml-6 mb-6 z-20 transition-all duration-300 ease-in-out"
        :class="isVideoStarted ? 'mb-10' : 'mb-6'"
      >
        <svg v-if="card.content.socialNetwork === 'instagram'"
             xmlns="http://www.w3.org/2000/svg"
             width="24"
             height="24"
             fill="none"
        >
          <g clip-path="url(#a)">
            <path fill="#9C1917"
                  fill-rule="evenodd"
                  d="M8.22 2.888c.978-.045 1.29-.055 3.78-.055 2.49 0 2.801.01 3.778.055.977.044 1.643.2 2.227.426a4.51 4.51 0 0 1 1.623 1.058c.467.458.827 1.011 1.057 1.623.226.583.381 1.25.426 2.225.045.979.055 1.29.055 3.78 0 2.49-.01 2.801-.055 3.779-.044.975-.2 1.642-.426 2.225a4.496 4.496 0 0 1-1.057 1.624 4.494 4.494 0 0 1-1.623 1.057c-.584.226-1.25.381-2.225.426-.979.045-1.29.055-3.78.055-2.49 0-2.802-.01-3.78-.055-.974-.044-1.641-.2-2.224-.426a4.498 4.498 0 0 1-1.625-1.057 4.494 4.494 0 0 1-1.057-1.623c-.226-.584-.381-1.25-.426-2.225-.045-.98-.055-1.291-.055-3.78 0-2.49.01-2.802.055-3.779.044-.976.2-1.643.426-2.226A4.497 4.497 0 0 1 4.372 4.37a4.493 4.493 0 0 1 1.623-1.057c.583-.226 1.25-.381 2.225-.426Zm7.484 1.65c-.967-.044-1.257-.053-3.704-.053-2.448 0-2.738.009-3.704.053-.895.04-1.38.19-1.703.316a2.847 2.847 0 0 0-1.054.685 2.843 2.843 0 0 0-.685 1.054c-.126.323-.275.808-.316 1.703-.044.966-.053 1.256-.053 3.704 0 2.447.009 2.737.053 3.704.04.894.19 1.379.316 1.702.147.398.38.759.685 1.055.296.304.657.538 1.054.684.323.126.808.276 1.703.316.966.045 1.255.054 3.704.054 2.448 0 2.737-.01 3.704-.054.894-.04 1.379-.19 1.702-.316a2.847 2.847 0 0 0 1.055-.684c.304-.296.538-.657.684-1.055.126-.323.276-.808.316-1.702.045-.967.054-1.257.054-3.704 0-2.448-.01-2.738-.054-3.704-.04-.895-.19-1.38-.316-1.703a2.847 2.847 0 0 0-.684-1.054 2.844 2.844 0 0 0-1.055-.685c-.323-.126-.808-.275-1.702-.316Zm-4.875 10.287a3.058 3.058 0 1 0 2.201-5.704 3.059 3.059 0 0 0-2.201 5.704ZM8.668 8.668a4.712 4.712 0 1 1 6.663 6.663 4.712 4.712 0 0 1-6.663-6.663Zm9.088-.678a1.113 1.113 0 0 0-.78-1.925 1.115 1.115 0 1 0 .78 1.925Z"
                  clip-rule="evenodd"
            />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M2 2h20v20H2z" />
            </clipPath>
          </defs>
        </svg>
        <svg v-else-if="card.content.socialNetwork === 'tiktok'"
             xmlns="http://www.w3.org/2000/svg"
             width="24"
             height="24"
             fill="none"
        >
          <path fill="#9C1917" d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48Z" />
        </svg>
        <svg
          v-else-if="card.content.socialNetwork === 'snapchat'"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
        >
          <g clip-path="url(#clip0_158_419)">
            <path fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.99043 5.65906C3.02634 2.80159 5.12691 0.666626 8.00007 0.666626C10.8732 0.666626 12.9738 2.80161 13.0097 5.65909C13.0102 5.69633 13.0106 5.73383 13.011 5.77166C13.1287 5.73733 13.2374 5.70676 13.3326 5.68063C13.6468 5.59436 14.1803 5.51189 14.6524 5.83579C14.973 6.05586 15.3054 6.43533 15.4396 7.04243C15.5622 7.59716 15.3294 8.09776 15.0262 8.42223C14.712 8.75853 14.1661 9.29733 13.3428 9.96333C13.5215 10.3141 13.8779 10.6043 14.2508 10.7662C14.2608 10.7705 14.271 10.7749 14.2813 10.7794C14.4859 10.868 14.7536 10.984 14.966 11.1341C15.2036 11.3019 15.5007 11.6041 15.5007 12.0835C15.5007 12.6348 15.1809 12.9889 14.8662 13.1923C14.5961 13.3669 14.2704 13.4707 14.0582 13.5383C14.0483 13.5415 14.0385 13.5446 14.0291 13.5476C13.957 13.5706 13.8964 13.59 13.8409 13.6093C13.8012 13.6231 13.7693 13.635 13.7435 13.6456C13.7274 13.6913 13.7075 13.7586 13.6786 13.864C13.6754 13.8756 13.6721 13.8877 13.6687 13.9002C13.5913 14.186 13.4478 14.7151 12.9391 15.0723C12.6318 15.2881 12.2913 15.3394 12.0078 15.3436C11.7414 15.3476 11.4544 15.3092 11.2069 15.2761L11.1811 15.2726C10.8723 15.2314 10.5812 15.1933 10.2781 15.1933C10.1866 15.1933 10.1345 15.214 10.0827 15.2466C10.0091 15.293 9.93631 15.3623 9.79597 15.5042C9.79101 15.5092 9.78597 15.5143 9.78084 15.5195C9.63777 15.6644 9.42851 15.8763 9.14551 16.0411C8.83507 16.222 8.46344 16.3335 8.00007 16.3335C7.53667 16.3335 7.16504 16.222 6.85461 16.0411C6.57164 15.8763 6.36234 15.6644 6.21927 15.5195C6.21414 15.5143 6.20911 15.5092 6.20414 15.5042C6.06381 15.3623 5.99107 15.293 5.91744 15.2466C5.86564 15.214 5.81357 15.1933 5.72207 15.1933C5.41891 15.1933 5.12784 15.2314 4.81901 15.2726L4.79324 15.2761C4.54571 15.3092 4.25874 15.3476 3.99231 15.3436C3.70881 15.3394 3.36831 15.2881 3.06098 15.0723C2.5523 14.7151 2.40887 14.186 2.3314 13.9002C2.328 13.8877 2.32472 13.8756 2.32155 13.864C2.29266 13.7586 2.2727 13.6913 2.2566 13.6456C2.23086 13.635 2.19891 13.6231 2.15917 13.6093C2.10369 13.59 2.04313 13.5706 1.97105 13.5476C1.96159 13.5446 1.95186 13.5415 1.94188 13.5383C1.72967 13.4707 1.40401 13.3669 1.13395 13.1923C0.8192 12.9889 0.49939 12.6348 0.49939 12.0835C0.49939 11.6041 0.79648 11.3019 1.03414 11.1341C1.24655 10.9841 1.51425 10.868 1.7188 10.7794C1.72915 10.7749 1.73933 10.7705 1.74934 10.7662C2.12226 10.6043 2.47867 10.3141 2.65735 9.96333C1.83401 9.29733 1.28813 8.75853 0.973916 8.42223C0.670746 8.09776 0.437933 7.59716 0.560566 7.04243C0.694766 6.43533 1.0271 6.05586 1.34777 5.83579C1.81978 5.51189 2.35328 5.59436 2.66753 5.68063C2.76276 5.70676 2.87143 5.73733 2.9891 5.77166C2.98952 5.73383 2.98996 5.69633 2.99043 5.65906ZM8.00007 1.99996C5.87471 1.99996 4.35064 3.53007 4.32364 5.67583C4.31987 5.97529 4.31781 6.29449 4.31781 6.63429V6.68363C4.31781 6.90026 4.21254 7.10339 4.03557 7.22829C3.85857 7.35323 3.63191 7.38433 3.42781 7.31176C3.02849 7.16979 2.60976 7.04743 2.31459 6.96639C2.22502 6.94183 2.16115 6.93499 2.12101 6.93663C2.10832 6.93716 2.10051 6.93836 2.09636 6.93923C2.02106 6.99239 1.91399 7.09716 1.86247 7.33023C1.86055 7.33889 1.85869 7.35653 1.86952 7.38829C1.88114 7.42233 1.90594 7.46676 1.94818 7.51196C2.25936 7.84503 2.8659 8.44293 3.83541 9.19573C4.02484 9.34279 4.12064 9.58026 4.08637 9.81759C3.92047 10.9661 2.97472 11.6878 2.28026 11.9892C2.1628 12.0402 2.06627 12.0823 1.98054 12.1239C1.97594 12.1262 1.97143 12.1284 1.967 12.1306C1.99473 12.1432 2.02613 12.1564 2.0616 12.1701C2.15589 12.2067 2.25759 12.2394 2.37701 12.2776L2.39385 12.283C2.52185 12.3238 2.6867 12.3765 2.83076 12.4412C2.96204 12.5002 3.21015 12.6246 3.36377 12.8788C3.49367 13.0938 3.55957 13.3358 3.60047 13.4859C3.60287 13.4948 3.60521 13.5034 3.60744 13.5116C3.69677 13.8375 3.73994 13.9198 3.82714 13.9811C3.82741 13.9812 3.86291 14.0082 4.01217 14.0104C4.16921 14.0128 4.36101 13.9886 4.64244 13.951L4.65634 13.9492C4.95337 13.9095 5.32357 13.86 5.72207 13.86C6.45591 13.86 6.87317 14.2835 7.12704 14.5411C7.13564 14.5499 7.14404 14.5584 7.15227 14.5667C7.30951 14.7257 7.40761 14.8202 7.52587 14.8891C7.62684 14.9479 7.76587 15.0002 8.00007 15.0002C8.23427 15.0002 8.37331 14.9479 8.47427 14.8891C8.59254 14.8202 8.69064 14.7258 8.84784 14.5667C8.85607 14.5584 8.86451 14.5499 8.87311 14.5411C9.12697 14.2835 9.54421 13.86 10.2781 13.86C10.6766 13.86 11.0467 13.9095 11.3438 13.9492L11.3577 13.951C11.6391 13.9886 11.8309 14.0128 11.988 14.0104C12.1372 14.0082 12.1727 13.9812 12.173 13.9811C12.2602 13.9198 12.3033 13.8375 12.3927 13.5116C12.3949 13.5034 12.3973 13.4948 12.3997 13.4859C12.4405 13.3358 12.5065 13.0938 12.6364 12.8788C12.79 12.6246 13.0381 12.5002 13.1694 12.4412C13.3134 12.3765 13.4782 12.3238 13.6062 12.283L13.6231 12.2776C13.7425 12.2394 13.8442 12.2067 13.9385 12.1701C13.974 12.1564 14.0054 12.1432 14.0331 12.1306C14.0287 12.1284 14.0242 12.1262 14.0196 12.1239C13.9339 12.0823 13.8373 12.0402 13.7199 11.9892C13.0254 11.6878 12.0797 10.9661 11.9138 9.81759C11.8795 9.58026 11.9753 9.34279 12.1647 9.19573C13.1342 8.44293 13.7408 7.84503 14.052 7.51196C14.0942 7.46676 14.119 7.42233 14.1306 7.38829C14.1414 7.35653 14.1396 7.33889 14.1377 7.33023C14.0861 7.09716 13.9791 6.99239 13.9038 6.93923C13.8996 6.93836 13.8918 6.93716 13.8791 6.93663C13.839 6.93499 13.7751 6.94183 13.6855 6.96639C13.3904 7.04743 12.9716 7.16979 12.5723 7.31176C12.3682 7.38433 12.1416 7.35323 11.9646 7.22829C11.7876 7.10339 11.6823 6.90026 11.6823 6.68363V6.63429C11.6823 6.29449 11.6802 5.97529 11.6765 5.67583C11.6495 3.53008 10.1255 1.99996 8.00007 1.99996Z"
                  fill="#9C1917"
            />
          </g>
          <defs>
            <clipPath id="clip0_158_419">
              <rect width="16"
                    height="16"
                    fill="white"
                    transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
        <svg
          v-else-if="card.content.socialNetwork === 'facebook'"
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          fill="none"
        >
          <path fill="#9C1917"
                d="M9 2.481c-.5 0-1 0-1 1.002v1.172h1.13c.403 0 .76.358.76.762v.941a.783.783 0 0 1-.76.762H8v6.38a.5.5 0 0 1-.5.5H5.72a.5.5 0 0 1-.5-.5V7.12H4.18a.783.783 0 0 1-.76-.762v-.941c0-.404.357-.762.76-.762h1.04c0-1.304-.225-2.693.737-3.737.832-.905 1.92-.936 3.035-.914.21.005.421.005.63.014a.77.77 0 0 1 .738.76v.942a.759.759 0 0 1-.76.761H9Z"
          />
        </svg>
        <span class="font-ltr">{{ card.content.username }}</span>
      </div>
    </template>
    <div
      v-if="card.comment"
      class="some-card-comment text-primary-red text-xs bg-white py-5 px-4"
    >
      <p
        class="font-light mb-2"
        :class="card.comment.rtlLayoutEnabled ? 'comment-rtl-alignment' : 'comment-ltr-alignment'"
        v-html="card.comment.text"
      />
      <span class="font-bold">@{{ card.comment.username }}</span>
    </div>
  </div>
</template>

<script>
import Picture from '@/components/Picture.vue'
import SoMeVideo from '@/components/SoMeVideo.vue'

export default {
  components: {
    SoMeVideo,
    Picture
  },
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isVideoStarted: false
    }
  },
  methods: {
    videoPlayPressed(player) {
      const videoDuration = player.duration() * 1000
      this.isVideoStarted = true
      this.$emit('videoPlaying', videoDuration)
    },
    pushDataLayer(obj) {
      if (window.dataLayer) {
        window.dataLayer.push(obj)
      }
    },
    trackCtaClick(title) {
      const cleanTitle = title.replace(/<[^>]*>/g, '')
      const gtmObj = {
        event: 'someGridCTAClick',
        someCardTitle: cleanTitle,
        placement: window.gtmData?.pageName
      }
      this.pushDataLayer(gtmObj)
    }
  }
}
</script>
